// extracted by mini-css-extract-plugin
export var textInput = "_jl-0";